import React, { useEffect, useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import { callQueryapi } from "../../services/http/callapi";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
    setcustomerprofile,
    setrnuserdetails,
    setISB2BCPRNumber,
    setLoginType,
    setIsPaciLogin,
    setUserLoggedInNumber
  } from "../../reducer/actions";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import {
    EndPointUserDetails,
  } from "../../services/common/endpoints";
import {useLocation, useNavigate} from "react-router-dom";
import { setItemInSessionStorage } from "../../services/common/utils";
import {isB2BCPRNumber} from "../../services/common/CommonUtils";
import { doFunct, setItem } from "../../services/common/utils";
import {
    CHILDMSISDN,
    SELECTED_MSISDN,
} from "../../services/common/Constants";
import { useTranslation } from 'react-i18next';
import { setSelectedNumber, setChildMsisdn, settoken, setRatePlanType } from '../../reducer/actions';
import BottomModalComponent from "./../../components/common/bottom-modal";
import { setPaciLogin, setPaciErrorFlag } from "../../reducer/utilitySlice";
import Loadingcomponent from "../loader/loadingcomponent";

  import {
    LOGOUT_API,
  } from "../../services/common/endpoints";
import {
    getItemOfSessionStorage,
} from "../../services/common/utils";

const PaciMangeLines = () => {

    const { t } = useTranslation();
    const dispatch= useDispatch();
    const [enableProfileAPIs, setenableProfileAPIs] = useState(false);
    const  {state}= useLocation();
    const navigate = useNavigate();
    const [showerrorpopup, setShowErrorPoup] = useState(false);
    const {
        utilityData: { globalSetting, isPaciLogin, civilID },
      } = useSelector((state) => state);
    const [tabsList, setTabsList] = useState([]);
    const [enableLogoutApi, setenableLogoutApi] = useState(false);
    
    const [filtereddata, setFilteredData] = useState();
    
    //Paci Number list data
    const {
        data: { data } = {},
        isLoading
      } = useQuery(
        ["", '/v6/api/paci/numberslist',{"civilid": state?.civilID}, {}], 
        {
            retry: false,
            cacheTime: 0,
            staleTime: 0,
        },
    )
    
    //data token id generation api
    const dataTokken = useMutation((req)=>
    callQueryapi({
       queryKey: ["", '/v6/api/paci/gettoken', req],
    }),
    {
        retry: false,
        catcheTime: 0,
        staleTime: 0, 
        onSuccess: ({data}) =>{
            console.log(data)
            try {
                dispatch(settoken(data?.response?.tokenid))
                setenableProfileAPIs(true);
            } catch (e) {}
        }
    })

    //User Authentication
    const rnuserdetails = useQuery(
        ["", EndPointUserDetails.url, EndPointUserDetails.data, {}, false],
        {
            retry: false,
            retryOnMount: true,
            enabled: enableProfileAPIs,
            cacheTime: 0,
            staleTime: 0
        }
    );

    // civilId Authentication
    const userDetailsApi = useQuery(
    [
        "",
        "customerprofile/get",
        { source: "homepage", sec: "splash" },
        {},
        false,
    ],
    {
        retry: false,
        retryOnMount: true,
        enabled: enableProfileAPIs,
        cacheTime: 0,
        staleTime: 0,
    }
    );
    
    // LogOut api 
    const { data: { LogOutdata } = {} } = useQuery(["", LOGOUT_API, {}, {}, false], {
        enabled: enableLogoutApi,
        retry: false,
    });

    useEffect(()=>{
        try{
            if(isPaciLogin){
                dispatch(setPaciLogin(false));
                dispatch(setPaciErrorFlag(false))               
            }
        }catch{}
    }, [])

    useEffect(()=>{
        if(data?.response){
            if(data?.status === "0" && data?.response?.length > 0){
                setFilteredData(data?.response)
                for(let item of data?.response){
                    if(item?.NonAccountMsisdn){
                    if(!tabsList.includes("Added number")){
                    tabsList.push("Added number")
                    }
                    }else{
                    if(!tabsList.includes(item?.heading)){
                    tabsList.push(item?.heading)
                    }
                }
                }
                tabsList?.sort()?.reverse()?.splice(0,0,t("All"))

            }
            else{
                setShowErrorPoup(true)                           
                setTimeout(function () {
                    navigate("/#");
                }, 2000);
            }
        }
    }, [data])

    const handleClick = (e) =>{
        if(e === t("All")){
            setFilteredData(data?.response)
        }
        else{
            setFilteredData(data?.response?.filter(item => item?.heading === e))
        }
    }

    const managelineselectclick = (x) => {
        if (x.NonAccountMsisdn == true) {
        } else {
          let encMobile = doFunct(x.msisdn, "MOBAPI");
          setItem(CHILDMSISDN, encMobile);
          setItem(SELECTED_MSISDN, x.cmsisdn);
          try {
            dispatch(setSelectedNumber(x.cmsisdn));
            dispatch(setUserLoggedInNumber(x.cmsisdn));
            dispatch(setChildMsisdn(x.cmsisdn))
          } catch (e) {}
          dataTokken.mutate({"msisdn": x.msisdn ,"transid": state?.transid }) 
        }
    };

    const toggleerrorbottomModal = () => {
        setShowErrorPoup(!showerrorpopup);
    };

    useEffect(() => {
        if (userDetailsApi.isSuccess && userDetailsApi?.data?.data) {
            dispatch(setcustomerprofile(userDetailsApi?.data?.data?.response));
          }
    if (userDetailsApi.isSuccess && userDetailsApi?.data?.data) {
        dispatch(setrnuserdetails(rnuserdetails?.data?.data?.response));
        dispatch(setcustomerprofile(userDetailsApi?.data?.data?.response));
        setItemInSessionStorage("Customerid",userDetailsApi?.data?.data?.response?.CustomerID);
        dispatch(setLoginType("Paci"));
        try{
        var _isB2BCpr = isB2BCPRNumber(userDetailsApi?.data?.data?.response);
        dispatch(setISB2BCPRNumber(_isB2BCpr));
        }catch{}
    }
    if (rnuserdetails.isSuccess && rnuserdetails?.data?.data) {
        dispatch(setrnuserdetails(rnuserdetails?.data?.data?.response));
        try {
            let _msisdn = "";
            if (rnuserdetails?.data?.data?.response?.msisdn && rnuserdetails?.data?.data?.response?.msisdn.length == 11)
              _msisdn = rnuserdetails?.data?.data?.response?.msisdn.slice(3);
            else
              _msisdn = rnuserdetails?.data?.data?.response?.msisdn
              try{
              if(_msisdn == null || _msisdn == undefined || _msisdn == "" || _msisdn == "undefined"){
                if (userDetailsApi?.data?.data?.response?.Msisdn && userDetailsApi?.data?.data?.response?.Msisdn.length == 11)
                _msisdn = userDetailsApi?.data?.data?.response?.Msisdn.slice(3);
              else
                _msisdn = userDetailsApi?.data?.data?.response?.Msisdn
              }
            }catch{}
            dispatch(setSelectedNumber(_msisdn));
            dispatch(setUserLoggedInNumber(_msisdn));
          } catch (e) { }
    }
    if (rnuserdetails?.isSuccess && userDetailsApi?.isSuccess) {
        
          try {
            global.userdetails = rnuserdetails?.data?.data?.response;
            global.rateplantype = userDetailsApi?.data?.data?.response.RatePlanType;
            //console.log("global.userdetails:"+JSON.stringify(global.userdetails)+"")
            try {
              dispatch(
                setRatePlanType(userDetailsApi?.data?.data?.response?.RatePlanType)
              );
            } catch {}
          } catch (e) {}
        //alert("issuccess");
        setItemInSessionStorage("pacilogin", "true");
        setItemInSessionStorage("loginStatus", "Loged with paci civilid");
        dispatch(setIsPaciLogin(true))
        navigate("/home/index");
    }
    }, [
    userDetailsApi?.data?.data,
    userDetailsApi.isSuccess,
    rnuserdetails?.data?.data,
    rnuserdetails.isSuccess,
    ]);

    return (
    <div className="pse_sm mt-4">
    {isLoading || userDetailsApi.isLoading || rnuserdetails.isLoading || enableProfileAPIs ? <Loadingcomponent></Loadingcomponent> : 
    <div>
      <h3 className="section_title_light mb-2">{t("managelines")}</h3>
      <p className="mb-3">{t("ctntl")}</p>
        <Tabs
            defaultActiveKey={t("All")}
            transition={true}
            id="uncontrolled-tab-example"
            className="cs_tabs mb-3"
            onSelect={(e)=> handleClick(e)}
        >
        {tabsList?.map((tabItem) => (
            <Tab 
                key={tabItem}
                id={tabItem}
                eventKey={tabItem} 
                title={tabItem}
            >
            {filtereddata?.map((x) => (
              <ul className="account_list">
                    <li
                      key={x.msisdn}
                      className="flex_grp_between"
                      style={{cursor: "pointer"}}
                      onClick={() => {
                        managelineselectclick(x);
                      }}
                    >
                      <div className="profile_info_v1">
                        <div className="profile_info_v1_img profile_info_img1 align-self-center">
                          <img
                            src={
                              x.image != ""
                                ? x.image
                                : process.env.PUBLIC_URL +
                                  "/assets/images/profileicon.png"
                            }
                            alt=""
                            title=""
                          />
                        </div>
                        <div className="profile_info_v1_desc">
                          <div className="flex_grp_align_center okw-line-clamp">
                            <h3 className="okw-h1-title">
                              {x?.nickname?.length > 0
                                ? x?.nickname
                                : t("nickname")}
                            </h3>
                          </div>
                          <h4>{x.cmsisdn}</h4>
                          <p>{x.currentplan}</p>
                        </div>
                      </div>
                    </li>
                  
              </ul>
             ))}

            </Tab>))}
      </Tabs>
      </div>}
      <BottomModalComponent
        show={showerrorpopup}
        togglebottomModal={toggleerrorbottomModal}
        respmessage={t("no_register_numbers")}
        popuptype={"fail"}
      />
      </div>
    )
}
export default PaciMangeLines;